module.exports = {
    // mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
    linkActiveClass: "active",
    mode: 'history',
    // scrollBehavior (to, from, savedPosition){
    //   return {x: 0, y: 0};
    // },
    routes: [
        {
          path: '/s-mart',
            component: resolve => {
            // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
            // （代码分块）
            require.ensure(['./views/index.vue'], () => {
              resolve(require('./views/index.vue'))
            })
          }
        },
        {
            path: '/s-mart/medal',
            name: 'medal',
            component: require('./views/medal.vue')
        },
        {
          path: '/',
            component: resolve => {
              require.ensure(['./views/index.vue'], () => {
                resolve(require('./views/index.vue'))
              })
            }
        },
        {
            path: '/application_detail',
            component: require('./views/application_detail.vue'),
            meta: {keepAlive: false}
        },
        {
            path: '/s-mart/application_detail',
            component: require('./views/application_detail.vue'),
            meta: {keepAlive: false}
        },
        {
            path: '/s-mart/communities',
            component: require('./views/forum.vue'),
            meta: {keepAlive: false, title: '学习社区| 腾讯蓝鲸智云'}
        },
        //社区页面
        {
          path: '/community',
          name: 'Community',
          // component: require('./views/community/Developer.vue'),
          component: resolve => {
              require.ensure(['./views/community/Developer.vue'], () => {
                  resolve(require('./views/community/Developer.vue'))
              }, 'community-module')
          },
          meta: {
              title: 'S-mart | 腾讯蓝鲸智云'
          }
        },
        {
          path: '/community/ask',
          // component: require('./views/community/ask.vue')
          component: resolve => {
              require.ensure(['./views/community/ask.vue'], () => {
                  resolve(require('./views/community/ask.vue'))
              }, 'ask-module')
          },
        },
        {
            path: '/s-mart/no_collect',
            name: 'noCollect',
            component: require('./views/no_collect.vue')
        },
        {
          path: '/s-mart/community',
          name: 'community',
          redirect: '/s-mart/community/question',
          // component: require('./views/community/Developer.vue'),
          component: resolve => {
              require.ensure(['./views/community/Developer.vue'], () => {
                  resolve(require('./views/community/Developer.vue'))
              }, 'community-module')
          },
          children: [
            {
              path: '/s-mart/community/question',
              component: require('./views/community/topic.vue'),
              name: 'community-question',
              meta: {type: 'question', title: '问答｜腾讯蓝鲸智云'}
            },
            {
              path: '/s-mart/community/article',
              component: require('./views/community/article.vue'),
              name: 'community-article',
              meta: {type: 'article', title: '文章｜腾讯蓝鲸智云'}
            },
            // {
            //   path: '/s-mart/community/activity',
            //   component: require('./views/community/activity.vue'),
            //   name: 'community-activity',
            //   meta: {type: 'activity'}
            // }
          ],
          meta: {
              title: 'S-mart | 腾讯蓝鲸智云'
          }
        },
        {
          path: '/s-mart/community/search',
          component: require('./views/community/search.vue'),
          name: 'community-search'
        },
        {
          path: '/s-mart/community/ask',
          name: 'communityAsk',
          // component: require('./views/community/ask.vue')
          component: resolve => {
              require.ensure(['./views/community/ask.vue'], () => {
                  resolve(require('./views/community/ask.vue'))
              }, 'ask-module')
          },
          name: 'community-ask'
        },
        {
          path: '/s-mart/community/preview',
          name: 'communityPreview',
          component: require('./views/community/preview.vue'),
          name: 'community-preview'
        },
        {
          path: '/s-mart/community/question/:wid',
          // component: require('./views/community/deatils.vue'),
          component: resolve => {
              require.ensure(['./views/community/deatils.vue'], () => {
                  resolve(require('./views/community/deatils.vue'))
              }, 'question-module')
          },
          name: 'Question',
        },
        // {
        //   path: '/s-mart/community/activity/:wid',
        //   name: 'activityDetail',
        //   component: resolve => {
        //       require.ensure(['./views/community/activityDetail.vue'], () => {
        //           resolve(require('./views/community/activityDetail.vue'))
        //       }, 'activity-module')
        //   }
        // },
        {
          path: '/community/ask:wid',
          // name: 'myQuestion',
          // component: require('./views/community/ask.vue')
          component: resolve => {
              require.ensure(['./views/community/ask.vue'], () => {
                  resolve(require('./views/community/ask.vue'))
              }, 'ask-module')
          }
        },
        {
          path: '/s-mart/community/ask/:wid',
          name: 'communityAsk',
          // component: require('./views/community/ask.vue')
          component: resolve => {
              require.ensure(['./views/community/ask.vue'], () => {
                  resolve(require('./views/community/ask.vue'))
              }, 'ask-module')
          }
        },
        {
            path: '/market',
            component: resolve => {
                      // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                      // （代码分块）
                      require.ensure(['./views/market.vue'], () => {
                        resolve(require('./views/market.vue'))
                      })
                    },
            // beforeEnter(to, from, next) {
            //   console.log('router beforeEnter');
            //   next();
            // },
            // meta: {keepAlive: false}
        },
        {
            path: '/s-mart/market',
            name: 'market',
            component: resolve => {
                      // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                      // （代码分块）
                      require.ensure(['./views/market.vue'], () => {
                        resolve(require('./views/market.vue'))
                      })
                    },
            // beforeEnter(to, from, next) {
            //   console.log('router beforeEnter');
            //   next();
            // },
            // meta: {keepAlive: false}
        },
        {
            path: '/personal_center',
            component: resolve => {
                      // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                      // （代码分块）
                      require.ensure(['./views/personal_center.vue'], () => {
                        resolve(require('./views/personal_center.vue'))
                      })
                    },
            children: [
              {
                path: '',
                component: resolve => {
                          // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                          // （代码分块）
                          require.ensure(['./views/personal_center/index.vue'], () => {
                            resolve(require('./views/personal_center/index.vue'))
                          })
                        }
              },
              {
                path: 'profile',
                component: require("./views/personal_center/personal_profile.vue"),
                children: [
                  {
                    path: '',
                    // component: require("./views/personal_center/profile/info.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/info.vue'], () => {
                                resolve(require('./views/personal_center/profile/info.vue'))
                              })
                            }
                  },
                  {
                    path: 'social',
                    component: require("./views/personal_center/profile/social.vue")
                    // component: resolve => {
                    //           // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                    //           // （代码分块）
                    //           require.ensure(['./views/personal_center/profile/social.vue'], () => {
                    //             resolve(require('./views/personal_center/profile/social.vue'))
                    //           })
                    //         }
                  },
                  {
                    path: 'identity',
                    // component: require("./views/personal_center/profile/identity.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/identity.vue'], () => {
                                resolve(require('./views/personal_center/profile/identity.vue'))
                              })
                            }
                  },
                  {
                    path: 'privacy',
                    // component: require("./views/personal_center/profile/privacy.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/privacy.vue'], () => {
                                resolve(require('./views/personal_center/profile/privacy.vue'))
                              })
                            }
                  },
                  {
                    path: 'security',
                    // component: require("./views/personal_center/profile/security.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/security.vue'], () => {
                                resolve(require('./views/personal_center/profile/security.vue'))
                              })
                            }
                  },
                  {
                    path: 'log',
                    // component: require("./views/personal_center/profile/log.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/log.vue'], () => {
                                resolve(require('./views/personal_center/profile/log.vue'))
                              })
                            }
                  },
                ]
              },
              // {
              //   path: 'works',
              //   component: require('./views/personal_center/works.vue'),
              //   children: [
              //     {
              //       path: '',
              //       component: require('./views/personal_center/works/upload.vue'),
              //     },
              //     {
              //       path: 'download',
              //       component: require('./views/personal_center/works/download.vue'),
              //     },
              //   ]
              // },
              // {
              //   path: 'works/:wid',
              //   component: require('./views/personal_center/works_detail.vue'),
              //   children: [
              //     {
              //       path: 'detail',
              //       component: require('./views/personal_center/works/work_profile.vue'),
              //     },
              //     {
              //       path: 'work_profile',
              //       component: require('./views/personal_center/works/work_profile.vue'),
              //     },
              //     {
              //       path: 'basic_information',
              //       component: require('./views/personal_center/works/basic_information.vue'),
              //     },
              //     {
              //       path: 'works_pictures',
              //       component: require('./views/personal_center/works/basic_works_pictures.vue'),
              //     },
              //     {
              //       path: 'version_file',
              //       component: require('./views/personal_center/works/version_file.vue'),
              //     },
              //     {
              //       path: 'trading_mode',
              //       component: require('./views/personal_center/works/trading_mode.vue'),
              //     },
              //     {
              //       path: 'download_user',
              //       component: require('./views/personal_center/works/download_user.vue'),
              //     },
              //     {
              //       path: 'collect_user',
              //       component: require('./views/personal_center/works/collect_user.vue'),
              //     },
              //     {
              //       path: 'work_information',
              //       component: require('./views/personal_center/works/work_information.vue'),
              //     }
              //   ]
              // },
              // {
              //   path: 'user_upload',
              //   component: require('./views/personal_center/works/user_upload.vue'),
              // },
              // {
              //     path: 'works_detail',
              //     component: require('./views/personal_center/works_detail.vue')
              // },
              {
                path: 'my_attention',
                component: require('./views/personal_center/my_attention.vue'),
                children: [
                  {
                    path: '',
                    component: require('./views/personal_center/my_attention/attention.vue'),
                  },
                  {
                    path: 'fans',
                    component: require('./views/personal_center/my_attention/fans.vue'),
                  }
                ]
              },
              // {
                // path: 'notice',
                // component: require('./views/personal_center/notice.vue'),
                // children: [
                  // {
                  //   path: '',
                  //   component: require('./views/personal_center/notice/all_notice.vue'),
                  // },
                  //  {
                  //    path: 'at_me',
                  //    component: require('./views/personal_center/notice/at_me.vue'),
                  //  },
                  // {
                  //   path: 'message_set',
                  //   component: require('./views/personal_center/notice/message_set.vue'),
                  // }
                // ]
              // },
              // {
              //   path: 'message',
              //   component: require('./views/personal_center/message_log.vue'),
              //   children: [
              //     {
              //       path: '',
              //       component: require('./views/personal_center/message/all_message.vue'),
              //     },
              //     {
              //       path: 'unread',
              //       component: require('./views/personal_center/message/unread.vue'),
              //     }
              //   ]
              // },
              {
                path: 'deal_flow',
                component: require('./views/personal_center/deal_flow.vue'),
              }
            ]
        },
        {
            path: '/s-mart/personal_center',
            name: 'personal-center',
            component: resolve => {
                      // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                      // （代码分块）
                      require.ensure(['./views/personal_center.vue'], () => {
                        resolve(require('./views/personal_center.vue'))
                      })
                    },
            children: [
              {
                path: '',
                component: resolve => {
                        // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                        // （代码分块）
                        require.ensure(['./views/personal_center/index.vue'], () => {
                          resolve(require('./views/personal_center/index.vue'))
                        })
                      },
                meta: { name: '' },
                children: [
                  {
                    path: 'store',
                    meta: { name: '' },
                    component: require("./views/personal_center/store.vue")
                  }
                ]
              },
              {
                path: 'user/:uid',
                name: 'user-center',
                component: require("./views/personal_center/user_center.vue"),
                meta: { name: '' }
              },
              {
                path: 'profile',
                component: require("./views/personal_center/personal_profile.vue"),
                meta: { name: 'profile' },
                children: [
                  {
                    path: '',
                    meta: { name: 'profile' },
                    // component: require("./views/personal_center/profile/info.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/info.vue'], () => {
                                resolve(require('./views/personal_center/profile/info.vue'))
                              })
                            },
                  },
                  {
                    path: 'social',
                    meta: { name: 'profile' },
                    component: require("./views/personal_center/profile/social.vue")
                    // component: resolve => {
                    //           // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                    //           // （代码分块）
                    //           require.ensure(['./views/personal_center/profile/social.vue'], () => {
                    //             resolve(require('./views/personal_center/profile/social.vue'))
                    //           })
                    //         }
                  },
                  {
                    path: 'identity',
                    meta: { name: 'profile' },
                    // component: require("./views/personal_center/profile/identity.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/identity.vue'], () => {
                                resolve(require('./views/personal_center/profile/identity.vue'))
                              })
                            }
                  },
                  {
                    path: 'privacy',
                    meta: { name: 'profile' },
                    // component: require("./views/personal_center/profile/privacy.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/privacy.vue'], () => {
                                resolve(require('./views/personal_center/profile/privacy.vue'))
                              })
                            }
                  },
                  {
                    path: 'security',
                    meta: { name: 'profile' },
                    // component: require("./views/personal_center/profile/security.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/security.vue'], () => {
                                resolve(require('./views/personal_center/profile/security.vue'))
                              })
                            }
                  },
                  {
                    path: 'log',
                    meta: { name: 'profile' },
                    // component: require("./views/personal_center/profile/log.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/log.vue'], () => {
                                resolve(require('./views/personal_center/profile/log.vue'))
                              })
                            }
                  },
                  {
                    path: 'unbind',
                    meta: { name: 'profile' },
                    // component: require("./views/personal_center/profile/log.vue")
                    component: resolve => {
                              // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                              // （代码分块）
                              require.ensure(['./views/personal_center/profile/unbind.vue'], () => {
                                resolve(require('./views/personal_center/profile/unbind.vue'))
                              })
                            }
                  }
                ]
              },
              // {
              //   path: 'works',
              //   component: require('./views/personal_center/works.vue'),
              //   children: [
              //     {
              //       path: '',
              //       component: require('./views/personal_center/works/upload.vue'),
              //     },
              //     {
              //       path: 'download',
              //       component: require('./views/personal_center/works/download.vue'),
              //     },
              //   ]
              // },
              // {
              //   path: 'works/:wid',
              //   component: require('./views/personal_center/works_detail.vue'),
              //   children: [
              //     {
              //       path: 'detail',
              //       component: require('./views/personal_center/works/work_profile.vue'),
              //     },
              //     {
              //       path: 'work_profile',
              //       component: require('./views/personal_center/works/work_profile.vue'),
              //     },
              //     {
              //       path: 'basic_information',
              //       component: require('./views/personal_center/works/basic_information.vue'),
              //     },
              //     {
              //       path: 'works_pictures',
              //       component: require('./views/personal_center/works/basic_works_pictures.vue'),
              //     },
              //     {
              //       path: 'version_file',
              //       component: require('./views/personal_center/works/version_file.vue'),
              //     },
              //     {
              //       path: 'trading_mode',
              //       component: require('./views/personal_center/works/trading_mode.vue'),
              //     },
              //     {
              //       path: 'download_user',
              //       component: require('./views/personal_center/works/download_user.vue'),
              //     },
              //     {
              //       path: 'collect_user',
              //       component: require('./views/personal_center/works/collect_user.vue'),
              //     },
              //     {
              //       path: 'work_information',
              //       component: require('./views/personal_center/works/work_information.vue'),
              //     }
              //   ]
              // },
              // {
              //   path: 'user_upload',
              //   component: require('./views/personal_center/works/user_upload.vue'),
              // },
              // {
              //     path: 'works_detail',
              //     component: require('./views/personal_center/works_detail.vue')
              // },
              // {
              //   path: 'my_collection',
              //   component: require('./views/personal_center/my_collection.vue'),
              //   meta: { name: 'collection' }
              // },
              {
                path: 'product/:uid?',
                component: require('./views/personal_center/my_product.vue'),
                meta: { name: 'product' }
              },
              {
                path: 'article/:uid?',
                component: require('./views/personal_center/my_article.vue'),
                meta: { name: 'article' }
              },
              {
                path: 'question/:uid?',
                component: require('./views/personal_center/my_question.vue'),
                meta: { name: 'question' }
              },
              {
                path: 'sub_tag/:uid?',
                component: require('./views/personal_center/subscribe_tag.vue'),
                meta: { name: 'sub_tag' }
              },
              {
                path: 'history',
                component: require('./views/personal_center/history.vue'),
                meta: { name: 'history' }
              },
              {
                path: 'attention/:uid?',
                component: require('./views/personal_center/my_attention.vue'),
                meta: { name: 'attention' }
              },
              {
                path: 'notice',
                component: require('./views/personal_center/notice.vue'),
                // children: [
                //   {
                //     path: '',
                //     component: require('./views/personal_center/notice/all_notice.vue'),
                //   },
                //    {
                //      path: 'at_me',
                //      component: require('./views/personal_center/notice/at_me.vue'),
                //    },
                //   {
                //     path: 'message_set',
                //     component: require('./views/personal_center/notice/message_set.vue'),
                //   }
                // ]
              },
              // {
              //   path: 'message',
              //   component: require('./views/personal_center/message_log.vue'),
              //   children: [
              //     {
              //       path: '',
              //       component: require('./views/personal_center/message/all_message.vue'),
              //     },
              //     {
              //       path: 'unread',
              //       component: require('./views/personal_center/message/unread.vue'),
              //     }
              //   ]
              // },
              {
                path: 'deal_flow',
                component: require('./views/personal_center/deal_flow.vue'),
                meta: { name: 'deal_flow' }
              },
              {
                path: 'message_center',
                component: require('./views/personal_center/message_center.vue'),
                meta: { name: 'message_center' }
              }
            ]
        },
        // {
        //     path: '/personal/:uid',
        //     component: resolve => {
        //               // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
        //               // （代码分块）
        //               require.ensure(['./views/personal.vue'], () => {
        //                 resolve(require('./views/personal.vue'))
        //               })
        //             }
        // },
        // {
        //     path: '/s-mart/personal/:uid',
        //     component: resolve => {
        //               // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
        //               // （代码分块）
        //               require.ensure(['./views/personal.vue'], () => {
        //                 resolve(require('./views/personal.vue'))
        //               })
        //             }
        // },
        {
            path: '/application/:aid',
            component: resolve => {
                      // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                      // （代码分块）
                      require.ensure(['./views/application_detail.vue'], () => {
                        resolve(require('./views/application_detail.vue'))
                      }, 'group-application')
                    },
            children: [
              {
                path: 'detail',
                component: resolve => {
                          // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                          // （代码分块）
                          require.ensure(['./views/application/pro_detail.vue'], () => {
                            resolve(require('./views/application/pro_detail.vue'))
                          }, 'group-application')
                        }
                // component: require('./views/application/pro_detail.vue')
              },
              // {
                // path: 'data',
                // component: require('./views/application/data.vue')
                // component: require('./views/application/related_data.vue')
              // },
              {
                path: 'comment',
                component: require('./views/application/comment.vue')
              },
              {
                path: 'update',
                component: resolve => {
                          // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                          // （代码分块）
                          require.ensure(['./views/application/update.vue'], () => {
                            resolve(require('./views/application/update.vue'))
                          }, 'group-application')
                        }
              },
              {
                path: 'histroy',
                component: require('./views/application/histroy.vue')
              },
              {
                path: 'information',
                component: require('./views/application/information.vue')
              },
              {
                path: 'relate',
                component: require('./views/application/relate.vue')
              }
            ]
        },
        {
            path: '/s-mart/application/:aid',
            component: resolve => {
                      // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                      // （代码分块）
                      require.ensure(['./views/application_detail.vue'], () => {
                        resolve(require('./views/application_detail.vue'))
                      }, 'group-application')
                    },
            name: 'market-detail',
            children: [
              {
                path: 'detail',
                component: resolve => {
                          // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                          // （代码分块）
                          require.ensure(['./views/application/pro_detail.vue'], () => {
                            resolve(require('./views/application/pro_detail.vue'))
                          }, 'group-application')
                        }
                // component: require('./views/application/pro_detail.vue')
              },
              {
                path: 'data',
                // component: require('./views/application/data.vue')
                component: require('./views/application/related_data.vue')
              },
              {
                path: 'comment',
                component: require('./views/application/comment.vue')
              },
              {
                path: 'update',
                component: resolve => {
                          // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
                          // （代码分块）
                          require.ensure(['./views/application/update.vue'], () => {
                            resolve(require('./views/application/update.vue'))
                          }, 'group-application')
                        }
              },
              {
                path: 'histroy',
                component: require('./views/application/histroy.vue')
              },
              {
                path: 'information',
                component: require('./views/application/information.vue')
              },
              {
                path: 'relate',
                component: require('./views/application/relate.vue')
              }
            ]
        },
        {
          path: '/s-mart/vip',
          component: require('./views/honorSystem.vue'),
          name: 'community-vip'
        },
        {
          path: '/s-mart/honor',
          component: require('./views/honorRules.vue'),
          name: 'community-honor'
        },
        {
          path: '/s-mart/video',
          component: require('./views/video/index.vue'),
          name: 'video',
          meta: {
            title: '视频教程｜腾讯蓝鲸智云'
          }
        },
        {
          path: '/s-mart/online-env',
          component: require('./views/online_env/index.vue'),
          name: 'online-env',
          meta: {
            title: '在线体验｜腾讯蓝鲸智云'
          }
        },
        {
          path: '/s-mart/downloads',
          component: require('./views/downloads/index.vue'),
          name: 'downloads',
          meta: {
            title: '下载专区｜腾讯蓝鲸智云'
          }
        },
        {
            path: '/information',
            component: require('./views/information.vue')
        },
        {
            path: '/s-mart/information',
            component: require('./views/information.vue')
        },
        {
            path: '*',
            redirect: '/s-mart/communities'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router.js